import ShopArticleTaxHistoryModelBase from '../_generated/modelBases/shop-article-tax-history-model-base';

export default class ShopArticleTaxHistoryModel extends ShopArticleTaxHistoryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
